<template>
    <div class="logout">
        <h1>Logging out!</h1>
    </div>
</template>

<script setup>
    import { onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useCommonStore } from '../store/useCommonStore';
    const actionCookie = 'sessionAction';
    const route = useRoute()
    let redirectToClassic = (Uri, reason, messageId) => {
        if (Uri === null) {
            fetch('api/account/token')
                .then(r => {                   
                    return r.json();
                })
                .then(json => {
                    window.location.replace(json.eValuatorUri + '/Account/MyLogOff?logoutReason=' + reason + "&messageId=" + messageId);                  
                });
        } else {
            window.location.replace(Uri + '/Account/MyLogOff?logoutReason=' + reason + "&messageId=" + messageId); //get request
        }
    }
    onMounted(() => {
        const store = useCommonStore();
        let eValuatorUri = store.userLoggedIn() ? store.eValuatorUri : null;
        store.clearToken();
        sessionStorage.clear();
        const reason = route.query.reason ;
        const messageId = route.query.messageId ;
        redirectToClassic(eValuatorUri, reason, messageId);
    });    

</script>